import { useState } from "react";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";

import { useStoredLanguageRedirect } from "@/hooks/useLanguageSwitcher";

import WhatsAppWidget from "../WhatsAppWidget";
import DesktopNav from "./DesktopNav";
import MobileBar from "./MobileBar";
import MobileDrawer from "./MobileDrawer";
import TopBar from "./TopBar";
import { useAudience, useDesktopViewport } from "./navbar.hooks";
import { desktopOnly, stickyHeader } from "./navbar.styles";

/*
 * The site header for every page except the signed-in account area, which has
 * its own bar (components/UserNavbar).
 *
 * Which bar is visible is decided by CSS (see navbar.styles), so the server
 * renders the right one for every viewport and nothing flashes on hydration.
 * The media query on top of that only decides whether the desktop bar stays
 * *mounted*: below 900px it is invisible anyway, and unmounting it keeps its
 * account widget — which fetches profile and wallet data — off mobile.
 */
export default function Navbar({ isLoggedIn, onLogout, allProduct }) {
  const router = useRouter();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { audience, isCompanyAudience, selectAudience } = useAudience();
  const isDesktopViewport = useDesktopViewport();

  useStoredLanguageRedirect();

  return (
    <>
      {/* Product pages have their own conversion CTA in the same corner. */}
      {!router.pathname.startsWith("/products/") && <WhatsAppWidget />}

      <Box sx={stickyHeader}>
        {isDesktopViewport && (
          <Box sx={desktopOnly}>
            <TopBar audience={audience} onSelectAudience={selectAudience} />
            <DesktopNav
              isCompanyAudience={isCompanyAudience}
              isLoggedIn={isLoggedIn}
              onLogout={onLogout}
              allProduct={allProduct}
            />
          </Box>
        )}

        <MobileBar onOpenDrawer={() => setIsDrawerOpen(true)} />

        <MobileDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          audience={audience}
          isCompanyAudience={isCompanyAudience}
          onSelectAudience={selectAudience}
          isLoggedIn={isLoggedIn}
          onLogout={onLogout}
          allProduct={allProduct}
        />
      </Box>
    </>
  );
}
